import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getMyScheduleCountList(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getMyScheduleCountList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getMyscheduleList(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getMyscheduleList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getMyschedule(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getMyschedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  saveMyschedule(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/saveMyschedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getMyOrgList(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getMyOrgList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getScheduleListByUserid(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getScheduleListByUserid',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getUserInfoByUserid(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getUserInfoByUserid',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  cmplConcExpDueSchedule(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/cmplConcExpDueSchedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  cmplReinspecSchedule(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/cmplReinspecSchedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  cmplBookcareSchedule(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/cmplBookcareSchedule',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  getHdScheduleCountList(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getHdScheduleCountList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  getHdScheduleList(parameters={}) {
    return core.call({
      url: '/api/v1/myschedule/getHdScheduleList',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }
}
